import { StatisticsTranslate } from './statisticsTranslate.model';

const statisticsTranslatePTBR: StatisticsTranslate = {
  page: {
    title: 'Estatísticas',
    subtitle: 'Acompanhe as métricas financeiras e de operação do seu estúdio.',
  },
  tab: {
    exports: 'Exportações',
    statistics: 'Estatísticas',
  },
  planLocked: {
    title: 'Estatísticas indisponíveis no seu plano',
    description:
      'O painel completo de estatísticas está disponível em planos superiores. Faça upgrade para acompanhar suas métricas.',
  },
  dateRange: {
    label: 'Período',
    apply: 'Aplicar',
    clear: 'Limpar',
    from: 'De',
    to: 'Até',
    presets: {
      thisMonth: 'Este mês',
      lastMonth: 'Mês anterior',
      lastThreeMonths: 'Últimos 3 meses',
      thisYear: 'Este ano',
    },
  },
  delta: {
    vsPrevious: 'vs. período anterior',
  },
  tabs: {
    label: 'Seção das estatísticas',
    overview: 'Visão geral',
    byMonth: 'Por mês',
    byClient: 'Por cliente',
    compare: 'Comparar períodos',
  },
  byMonth: {
    title: 'Vendas por mês',
    chartTitle: 'Receita mês a mês',
    empty: 'Nenhuma venda no período selecionado',
    kpi: {
      totalRevenue: 'Receita total',
      averageMonthly: 'Média mensal',
      ticketAverage: 'Ticket médio',
      bestMonth: 'Melhor mês',
    },
    column: {
      month: 'Mês',
      revenue: 'Receita',
      salesCount: 'Vendas',
      ticketAverage: 'Ticket médio',
      newClients: 'Novos',
      returningClients: 'Recorrentes',
    },
  },
  byClient: {
    title: 'Vendas por cliente',
    empty: 'Nenhum cliente com venda no período',
    recurring: 'Recorrente',
    searchPlaceholder: 'Buscar cliente',
    sortLabel: 'Ordenar por',
    kpi: {
      totalRevenue: 'Receita total',
      totalClients: 'Clientes',
      recurringClients: 'Recorrentes',
      newClients: 'Novos',
    },
    column: {
      client: 'Cliente',
      revenue: 'Receita',
      salesCount: 'Vendas',
      ticketAverage: 'Ticket médio',
      lastSaleAt: 'Última compra',
    },
  },
  compare: {
    title: 'Comparar períodos',
    subtitle: 'Compare o período selecionado com outro intervalo.',
    currentPeriod: 'Período atual',
    currentHint: 'Ajuste no seletor de período acima.',
    previousPeriod: 'Período de comparação',
    reset: 'Usar período anterior',
    noBaseline: 'Sem base de comparação',
    column: {
      metric: 'Métrica',
      delta: 'Variação',
    },
    metric: {
      totalRevenue: 'Receita total',
      salesCount: 'Vendas',
      ticketAverage: 'Ticket médio',
      newClients: 'Clientes novos',
      returningClients: 'Clientes recorrentes',
      receivedAmount: 'Recebido no período',
    },
  },
  receivables: {
    title: 'Cobranças',
    subtitle: 'Quem está devendo e quem vence em breve.',
    overdueTitle: 'Em atraso',
    overdueEmpty: 'Nenhuma parcela em atraso',
    upcomingTitle: 'A vencer',
    upcomingEmpty: 'Nenhuma parcela a vencer',
    installmentLabel: 'Parcela {{number}}/{{total}}',
    daysOverdue_one: '{{count}} dia em atraso',
    daysOverdue_other: '{{count}} dias em atraso',
    kpi: {
      overdueAmount: 'Total em atraso',
      overdueClients: 'Clientes em atraso',
      upcomingAmount: 'A vencer (30 dias)',
    },
  },
  loadError: 'Não foi possível carregar as estatísticas. Tente novamente.',
  financial: {
    title: 'Financeiro',
    kpi: {
      totalRevenue: 'Receita total',
      ticketAverage: 'Ticket médio',
      salesCount: 'Nº de vendas',
      overdueAmount: 'Em atraso',
      receivedAmount: 'Recebido',
      pendingAmount: 'A receber',
    },
    revenueTimeseries: 'Receita mensal',
    paymentMethodMix: 'Mix por método de pagamento',
    topItems: {
      title: 'Top serviços e pacotes',
      name: 'Item',
      revenue: 'Receita',
      count: 'Qtd.',
      empty: 'Nenhuma venda no período.',
    },
    cashForecast: 'Previsão de caixa',
  },
  funnel: {
    title: 'Funil',
    kpi: {
      conversionRate: 'Taxa de conversão',
      newLeads: 'Leads novos',
      avgSalesCycle: 'Ciclo médio de venda',
    },
    days: 'dias',
    eventsByStatus: {
      title: 'Eventos por status',
      empty: 'Nenhum evento no período.',
    },
    contractsByStatus: {
      title: 'Contratos por status',
      empty: 'Nenhum contrato no período.',
      status: {
        DRAFT: 'Rascunho',
        ISSUED: 'Emitido',
        SIGNED: 'Assinado',
      },
    },
  },
  operational: {
    title: 'Operacional',
    seasonality: 'Sazonalidade (eventos por mês)',
    kpi: {
      avgBookingLeadTime: 'Antecedência média de reserva',
    },
    days: 'dias',
    leadsByBadge: {
      title: 'Leads por etiqueta',
      empty: 'Nenhuma etiqueta no período.',
    },
  },
  source: {
    title: 'Origens e perdas',
    unknown: 'Não informado',
    unknownReason: 'Outro',
    conversionBySource: {
      title: 'Conversão por origem',
      empty: 'Nenhum lead no período.',
      ratio: '{{withSale}}/{{total}} ({{rate}}%)',
    },
    lostReasons: {
      title: 'Motivos de perda',
      empty: 'Nenhuma perda no período.',
    },
  },
};

export default statisticsTranslatePTBR;
